export const FETCH_SELF_DETAILS = "FETCH_SELF_DETAILS";
export const FETCH_USERS_TO_IMPERSONATE = "FETCH_USERS_TO_IMPERSONATE";
export const EDIT_USER_DETAILS = "EDIT_USER_DETAILS";
export const SELECT_PROFILE = "SELECT_PROFILE";
export const FETCH_APP_LOGO = "FETCH_APP_LOGO";

// external action types
export const NS_FETCH_SELF_DETAILS = "auth/FETCH_SELF_DETAILS";
export const NS_FETCH_USERS_TO_IMPERSONATE = "auth/FETCH_USERS_TO_IMPERSONATE";
